import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';

export const FeaturesEmbed: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="bg-sml-light py-5">
      <Container className="py-5">
        <h2 className="main-header text-center pt-5 pb-3 text-secondary">
          {intl.formatMessage({
            id: 'sml.web.smartlinks.features.embed.title',
            defaultMessage: 'Embed'
          })}
        </h2>
        <p className="main-header-subtitle text-center">
          {intl.formatMessage({
            id: 'sml.web.smartlinks.features.embed.drive-streams.title',
            defaultMessage: 'Embed a sleek player on websites and blogs.'
          })}
        </p>
        <Row className="py-5">
          <Col xs={12} className="text-center px-4">
            {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
            <iframe
              width="400px"
              height="800px"
              src="https://empawaafrica.fym.fm/embed/bestofmreazi"
              frameBorder="0"
              allow="encrypted-media"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
